import React from 'react';
import { withRouter } from 'react-router-dom';
import scrollAppToTop from './components/Utils/scrollToTop';

/**
 * Resets the scroll position on every route change.
 *
 * This only catches navigations that change the URL. Pages that swap
 * sub-screens in place (Boost, Customer, Machine Picture, the report list ->
 * detail views) keep the same route, and are handled where their toolbar title
 * changes — see TopToolbar. Both paths go through the same
 * `scrollAppToTop()` helper, which knows the app scrolls inside
 * `.shipment-background` rather than the window.
 */
class ScrollToTop extends React.Component {
  componentDidUpdate(prevProps) {
    const { location } = this.props;
    const prev = prevProps.location;
    if (
      location.pathname !== prev.pathname ||
      location.search !== prev.search
    ) {
      scrollAppToTop();
    }
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(ScrollToTop);
